import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//  import BRAND_LOGO from '../../images/AOL_Gif.gif';
import { BRAND_LOGO } from '../../config';
 import '../../../src/styles/home.css';
//  import Footer from '../Footer';
//  import SideBar from '../SideBar';
 import SideBarSmallScreen from '../SideBarSmallScreen';
// import SideBarTest from '../SideBarNew';

// Import generic components
import Button from '../../generic_components/Button/Button';
import Footer from '../../generic_components/Footer/Footer';
import { webURL } from '../../config';



const Home = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const serversResponseData = useSelector(state => state.serversData);
    const servers = serversResponseData.servers;

    const isSmallScreen = window.innerWidth < 600;

    function getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [key, value] = cookie.split("=");
        if (key === name) return decodeURIComponent(value);
      }
      return null;
    }

    function deleteCookie(name) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    let user = window.localStorage.getItem('email');
    const emailFromCookies = getCookie("email");

    // Sync cookie to localStorage if localStorage is empty
    if (!user && emailFromCookies) {
      user = emailFromCookies;
      window.localStorage.setItem('email', user);
    }

    // If no user in localStorage, clear the cookie
    if (!user && emailFromCookies) {
      deleteCookie('email');
    }

    useEffect(() => {
        if (servers.length) {
          setLoading(false);
        }
    }, [servers, loading]);

    return (
        <>
        {/* {!isSmallScreen && <div className='sidebar-container'><SideBar /></div>} */}

        <div className='home-container'>
            <div className='logo-container'>
                <img src={BRAND_LOGO} alt='SAMURAI' className='home-image'></img>
            </div>
            <div className='home-btn'>
                {user ? (
                    <Button variant='gradient' size='large' style={{width: '100%'}} onClick={() => navigate("/health")}>
                      <span>Go to the health dashboard</span>
                    </Button>
                ) : (
                    <Button variant='primary' size='large' style={{width: '100%'}} onClick={() => navigate("/auth/signin")}>
                      <span style={{ fontSize: '100%' }}>Please Login to continue</span>
                    </Button>
                )}
            </div>
        </div>

        {isSmallScreen && (
          <div className="home-sidebar-small"><SideBarSmallScreen /></div>
        )}

        <div className='home-footer-container'><Footer url={webURL}/></div>
        </>
    );
};


export default Home;